<app-loader-round [displayText]="miniStatus.getMessage()" [isVisible]="miniStatus.isVisible()" [overlayIsGray]="true"></app-loader-round>
<div *ngIf="dataReceived">
    <div id="tdm">{{message}}</div>
    <div id="tdq" *ngIf="onlineResult !== null && onlineResult.own_region">{{trans('systems.labels.deviceTransferQuestion')}} 1?</div>
    <div id="tdq" *ngIf="onlineResult !== null && !onlineResult.own_region">{{trans('systems.labels.deviceTransferQuestion')}} {{onlineResult.local_version}}?</div>
</div>